import { render, staticRenderFns } from "./MedicareSituation.vue?vue&type=template&id=b9d6b710&lang=pug"
import script from "./MedicareSituation.vue?vue&type=script&lang=js"
export * from "./MedicareSituation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/home/docker/code/frontend/components/Icon.vue').default})
